import React from 'react';
import { Link } from '@one-thd/sui-atomic-components';
import { func } from 'prop-types';

export const SaveSharedListButton = ({ onClick }) => {
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  return <Link component="button" onClick={onClick}>Save to Lists</Link>;
};

SaveSharedListButton.propTypes = {
  onClick: func.isRequired
};